import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';

let apiPath = "/api/library/libraryLinkInstitute.php"


const LinkedInstitutes = (props) => {

    const [linkedID, setLinkedID] = useState([]);
    const [selectedInstituteIdArray, setInstituteIdArray] = useState([]);
    const [successModal, setsuccessModal] = useState(false);
    const [successModalType, setsuccessModalType] = useState("");
    const [successMessage, setsuccessMessage] = useState("");
    const [instituteList, setInstituteList] = useState([]);
    const [facultyInstituteList, setFacultyInstituteList] = useState([]);

    useEffect(() => {
        apiToCallLinkedInstituteStatus();
        apiToCallFacultyAssignedInstituteList();
    }, [successModal])

    // faculty assigned all institute list
    const apiToCallFacultyAssignedInstituteList = async (action) => {
        let requestData = {
            "facultyId": config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetFacultyAssignedInstituteList',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiToCallFacultyAssignedInstituteList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult?.success == 'true') {
                    setInstituteList(apiResult.data);
                    // setFacultyInstituteList(apiResult.data);
                }
            }
            else {
                setsuccessModal(true);
                setsuccessModalType("error");
                setsuccessMessage("Something went wrong. Please try again later.");
            }
        }
    }

    // get linked institutes status and institute details
    const apiToCallLinkedInstituteStatus = async () => {

        let requestData = {
            "iid": config.institute_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiToCallLinkedInstituteStatus()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                let filteredData = Object.values(apiResult).map(Number);
                let finalData = filteredData.filter(item => typeof item === 'number' && !isNaN(item));
                let linkedInstituteData = jsonResponse.APIResult.linkedInstituteData;

                // if (jsonResponse.APIResult.data) {
                //     setInstituteList(linkedInstituteData)
                // } else {
                //     setInstituteList(facultyInstituteList)
                // }

                setLinkedID(finalData);
            }
            //else {
            //     this.setState({
            //         isStopListFetching: false,
            //         successModal: true,
            //         successModalType: 'error',
            //         successMessage: 'Something went wrong while getting stops list. Please try again later.'
            //     });
            // }
        }

    }

    // close success message modal
    const closeSuccessModal = () => {
        setsuccessModal(false);
        setInstituteIdArray([]);

    }

    // select ALL checkbox
    const AllCheckboxSelection = (e) => {
        let selectedIDs = new Set();

        if (e.target.checked) {
            Object.keys(instituteList).map(id => {
                if (id !== config.institute_id) {
                    selectedIDs.add(parseInt(id));
                }
            });
        }
        else {
            Object.keys(instituteList).map(id => {
                selectedIDs.delete(id);
            });
        }

        setInstituteIdArray(Array.from(selectedIDs))
        apiToCallLinkedInstituteStatus();

    }

    // select SINGLE checkbox
    const SingleCheckboxSelection = (instid) => {
        let singleselects = selectedInstituteIdArray;



        if (singleselects.includes(parseInt(instid))) {
            singleselects = singleselects.filter(id => id != parseInt(instid));
        }
        else {
            singleselects.push(parseInt(instid));
        }

        setInstituteIdArray(singleselects);
        apiToCallLinkedInstituteStatus()

    }

    // used to link/unlink institutes to library module
    const apiCallToPostLinkedInstitute = async (action) => {
        const editAccess = props.isAdmin == true ? true : props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editAccess !== undefined) {
            let linkedInstituteArray = [];
            let unlinkedInstituteArray = [];
            let instituteIDArray = Object.keys(instituteList);

            if (action == "link") {
                let instituteArray = selectedInstituteIdArray;

                linkedInstituteArray = [...instituteArray, ...linkedID];

                linkedInstituteArray = [...new Set(linkedInstituteArray)];

                unlinkedInstituteArray = instituteIDArray.filter((id) => !linkedInstituteArray.includes(parseInt(id)));
            }
            else {
                unlinkedInstituteArray = selectedInstituteIdArray;
                linkedInstituteArray = linkedID;
                linkedInstituteArray = linkedInstituteArray.filter((id) => !selectedInstituteIdArray.includes(parseInt(id)));

                unlinkedInstituteArray = instituteIDArray.filter((id) => !linkedInstituteArray.includes(parseInt(id)));
            }

            let requestData = {
                "linked_iid_array": linkedInstituteArray,
                "unlinked_iid_array": unlinkedInstituteArray,
                "employee_id": config.faculty_id,
                "action": action
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_LinkInstitute',
                requestData,
                apiPath
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiToCallLinkedInstituteStatus()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.message;

                    if (jsonResponse.APIResult.status == "success") {
                        setsuccessModal(true);
                        setsuccessModalType("success");
                        setsuccessMessage(apiResult);
                    }
                    else {
                        setsuccessModal(true);
                        setsuccessModalType("warning");
                        setsuccessMessage(apiResult);
                    }
                }

                else {
                    setsuccessModal(true);
                    setsuccessModalType("error");
                    setsuccessMessage("Something went wrong. Please try again later.");
                    // this.setState({
                    //     isStopListFetching: false,
                    //     successModal: true,
                    //     successModalType: 'error',
                    //     successMessage: 'Something went wrong while getting stops list. Please try again later.'
                    // });
                }
            }
            document.getElementById("allselect").checked = false;
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    return (
        <>
            <RoutingMenu activeScreen="linkedInstitute" />

            <div className="libraryComponents-container">
                <div className="row col-md-12">
                    <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => props.closeLinkedInstitute()} >
                        <FontAwesomeIcon className="viewGrievance-icon" icon={["fa", "angle-left"]} />
                    </button>
                    &nbsp;
                    <div className="mt-1">
                        <h3 style={{ fontSize: "28px" }}>Linked Institutes</h3>
                    </div>
                </div>

                <p style={{ textAlign: "left", fontSize: 14, padding: "10px", color: "red" }}><span style={{ fontWeight: "bold", color: "black" }}>Note:</span> Your current selected institute will always be displayed as 'Linked'.</p>

                <div className="table-responsive fixTableHead" id='tableResponsive' style={{ backgroundColor: "white" }}>
                    <table className="table table-bordered" id="maintenanceDetails" style={{ margin: 4, width: "98%" }}>
                        <thead>
                            <tr style={{ display: 'none' }}>
                                <th colSpan={4}>{ReactHtmlParser(config.instructorInfo.InstituteName)}</th>
                            </tr>
                            <tr>
                                {
                                    <th className="hidePrint">
                                        <input type="checkbox"
                                            id='allselect'
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => AllCheckboxSelection(e)}
                                        />
                                    </th>
                                }

                                <th>Sr. No.</th>
                                <th>Institute Name</th>
                                <th>Status</th>

                            </tr>
                            {
                                selectedInstituteIdArray.length > 0 &&
                                <tr className="active-row">

                                    <th colSpan={7} style={{ padding: 5 }}>
                                        <div className="componentAction-button">
                                            <span
                                                className="exportDetails"
                                                title="Click to Link institutes"
                                                onClick={() => apiCallToPostLinkedInstitute("link")}
                                            >
                                                Link
                                            </span>
                                            <span
                                                className="exportDetails"
                                                title="Click to unlink institutes"
                                                onClick={() => apiCallToPostLinkedInstitute("unlink")}
                                            >
                                                Unlink
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            }
                        </thead>
                        <tbody>
                            {
                                Object.keys(instituteList).length > 0 &&
                                Object.values(instituteList).map((institute, index) => {
                                    // Check if institute ID matches the config's institute_id
                                    const isConfigInstitute = config.institute_id == institute.iid;
                                    return (
                                        <tr>
                                            {
                                                <td className="hidePrint"><input disabled={isConfigInstitute} checked={selectedInstituteIdArray.includes(parseInt(institute.iid))} style={{ cursor: "pointer" }} type="checkbox"
                                                    onClick={() => SingleCheckboxSelection(institute.iid)}
                                                /></td>
                                            }
                                            <td>{index + 1}</td>
                                            <td><span className="ellipseTitle" style={{ width: 200 }} title={institute.institute_name}>{institute.institute_name}</span></td>
                                            <td><span style={{ fontWeight: 600 }}>{linkedID.includes(institute.iid) ? "Linked" : "Not linked"}</span></td>
                                        </tr>
                                    )
                                })

                            }
                        </tbody>
                    </table>
                </div>

                {
                    successModal &&
                    <SuccessModal
                        successModal={successModal}
                        successModalType={successModalType}
                        successMessage={successMessage}
                        closeSuccessModal={closeSuccessModal}
                    />
                }
            </div>
        </>
    )
}


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin

    };
};


export default connect(mapStateToProps)(LinkedInstitutes);